export { default } from "./AverageScore";
